import { TripPrivacyType, } from "../../trips/create-trip/v2/CreateTripForm.type";
export var CreateTripFormInitialData = {
    tripTitle: undefined,
    tripCategories: [],
    source: undefined,
    destination: undefined,
    startDate: undefined,
    endDate: undefined,
    description: undefined,
    highlights: [],
    inclusions: [],
    exclusions: [],
    coverImage: null,
    coverImageFile: null,
    privacy: TripPrivacyType.PUBLIC,
    meetingPoint: "",
    meetingTime: "",
    allowJoinRequests: true,
    maxParticipants: 0,
    invitedParticipants: [],
    modeOfTransport: "N/A",
    itinerary: [
        {
            id: "day-1",
            day: String(1),
            title: "Day 1",
            description: "Day 1 looks like",
            activities: [
                {
                    id: "act-1",
                    time: "N/A",
                    title: "N/A",
                    location: "N/A",
                    description: "N/A",
                },
            ],
        },
    ],
    logistics: {
        accommodation: {
            hotelName: "N/A",
            address: "N/A",
            checkIn: null,
            checkOut: null,
            confirmationFile: null,
        },
        transport: {
            number: "N/A",
            tickets: null,
        },
    },
};
